import React, {useEffect, useState} from "react";
import CustomCard from '../../../src/components/card/CustomCard';
import CustomCardHeader from '../../../src/components/card/CustomCardHeader';
import CardBody from '../../../src/components/card/CardBody';
import Input from '../../../src/components/form/Input';

import {useDispatch, useSelector} from "react-redux";
import {searchPaymentList} from "../../redux/slices/paymentVerificationSlice";
import TableItemLoader from "../../components/TableItemLoader";
import PaymentItem from "./components/PaymentItem";
import CustomButton from "../../components/CustomButton";
import {PAY_FOR} from "../../constants/commons";
import {RadioGroup, RadioItem} from "../../components/form/RadioGroup";

function PaymentVerification() {
  const dispatch = useDispatch()

  const [mobileNumber, setMobileNumber] = useState("")
  const [payFor, setPayFor] = useState(PAY_FOR[0])
  const {loading, error, paymentList} = useSelector((state => state.paymentVerification))

  const [isInit, setIsInit] = useState(true)


  useEffect(() => {
    if (paymentList.length === 0) {
      setMobileNumber("")
    }
  }, [paymentList])

  const isValid = () => {
    return mobileNumber.length === 10
  }

  const searchPaymentAction = () => {
    dispatch(searchPaymentList({mobileNumber: mobileNumber, payFor: payFor.value}))
    setIsInit(false)
  }


  return (
    <>
      <div className="bg-rand-100 pb-10 px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-2xl px-4">
          <RadioGroup>
            {PAY_FOR.map((p) => <RadioItem key={`${p.value}-${p.label}`} label={p.label} isChecked={p.value === payFor.value}
                                           onChanged={() => setPayFor(p)} name={p.label}
                                           className="text-white"
                                           value={payFor.value}/>)}
          </RadioGroup>
          <div className="flex space-x-4 items-start">
            <Input type="number" hasLabel={false} placeholder="Enter mobile number" value={mobileNumber}
                   className="h-12"
                   onChange={(event) => {
                     if (event.target.value.length <= 10) {
                       setMobileNumber(event.target.value)
                     }
                   }}/>
            <CustomButton className="py-3 px-8 text-md"
                          disabled={!isValid()} onClick={searchPaymentAction}>Search</CustomButton>
          </div>
        </div>
      </div>
      {!isInit &&
      <>
        <div className="h-24 w-full bg-rand-100"/>
        <div className="px-3 md:px-8 h-auto -mt-24">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4 mb-16">
              <CustomCard>
                {(loading || error.length > 0 || paymentList.length === 0) ?
                  <TableItemLoader loading={loading} error={error} isEmpty={paymentList.length === 0}
                                   retry={searchPaymentAction}/> : <>
                    <CustomCardHeader contentPosition="none">
                      <div className="w-full flex flex-col items-start sm:flex-row sm:items-center justify-between">
                        <h2 className="text-white text-2xl">{paymentList[0].user}</h2>
                        <p className="text-sm">Mobile Number: {mobileNumber}</p>
                      </div>
                    </CustomCardHeader>
                    <CardBody>
                      {paymentList.map((payment) => {
                        return <PaymentItem payment={payment}/>
                      })}
                    </CardBody>
                  </>
                 }

              </CustomCard>
            </div>
          </div>
        </div>
      </>
      }


    </>
  )
}

export default PaymentVerification